import { render, staticRenderFns } from "./AddProductToDb.vue?vue&type=template&id=79b57cb3"
import script from "./AddProductToDb.vue?vue&type=script&lang=ts"
export * from "./AddProductToDb.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports